<template>
  <div class="home">
    <b-row>
      <b-col cols="2" class="menu-vertical">
        <p class="text-white">SERVICES FOR :</p>
        <ul>
          <li>
            <a href="/"><font color="#FFFFFF" face="Arial">Electronics Recycling</font></a>
          </li>
        </ul>
        <p>
          <img src="assets/images/index.3.gif" alt="certificado">
        </p>
      </b-col>
      <b-col cols="10" class="contenido pt-3">
        <h4 class="text-justify" style="color:green;">Recycling Solutions for Corporate Social Responsibility</h4>
        <p class="text-justify">
          The call for more recycling has redefined business processes. Looking for innovative
          ays to responsibly dispose of your company’s industrial waste can be complex and time-consuming. 
          Finding the most financially favorable way to recycle adds an even greater burden.
        </p>
        <p class="text-justify">
          TheCyberYard.com can provide your company with comprehensive, no-landfill recycling
          or most of your manufacturing and distribution scrap, and your end-of-life electronic equipment. 
          We have experience providing extensive recycling to many Fortune 500 firms in the Midsouth since 2001.
        </p>
        
        <h4 class="text-justify" style="color:green;">Recyclable Materials</h4>
        <p class="text-justify">TheCyberYard.com specializes in recycling the following:</p>
        <ul class="text-justify">
         
          <li>End-of-life products (secure destruction available) </li>

          <li>IT equipment </li>

          <li>Polyurethane </li>

         <li> Polyethylene </li>

          <li>Polystyrene </li>

          <li>Polypropylene </li>

         <li> Polycarbonate </li>

         <li> ABS </li>

          <li>And most thermoplastics </li>
        </ul>
        <h4 class="text-justify">Memphis Recycling Services</h4>
        <p class="text-justify">
          TheCyberYard.com provides the following services for all your industrial waste including electronics, polystyrene, and polymers.
        </p>
        <br>
        

      </b-col>
    </b-row>
    
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  },
  data(){
    return{
      contador: 0
    }
  }
}
</script>

<style scoped>
#home {
  background-color: #e6e6e6;
}
.menu-vertical {
  background-color: #006600;
  width: 15%;
}
.contenido{
  background-color: #FFF;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .menu-vertical {
    display: none;
  }
}
</style>
